import http from "./http.common";
import authHeader from "./auth.header"
/**
 * Handles the signup HTTP request to add a new user to the database
 * The data needed for each user is First Name, Last Name, Username, Email, and Password
 */
const signup = ({ username, email, password, recaptcha_token }) => {
  return http.post(`/api/signup`, {
    username,
    email,
    password,
    recaptcha_token
  });
};

/**
 * Handles the login HTTP request to access your user profile
 * The data needed for each user is the username or email along with the password
 */
const login = ({ emailOrUsername, password, recaptcha_token }) => {
  return http
    .post(`/api/login`, { emailOrUsername, password, recaptcha_token })
};

const logout = () => {
  localStorage.removeItem("user");
};

const verify = (confirmationToken) => {
  return http.get(`/api/confirmation/${confirmationToken}`);
};

const convParamsToStr = (params) => {
  var ret = "";
  if (params != void 0) {
    let count = 0;
    for (const [key, value] of Object.entries(params)) {
      ret += (count==0) ? `${key}=${value}` : `&&${key}=${value}`;
      count ++;
    }
  } else {
    console.error('[error] invalid params',params)
  }
  return ret;
}

const gameplay = (reqType,params,state=null) => {

  if (state != null) {
    return http.get(`/api/gameplay/${reqType}`,{
      headers: { ...authHeader(state) },
    });
  }else if (params != null) {
    const paramStr = convParamsToStr(params);
    return http.get(`/api/gameplay/${reqType}?${paramStr}`);
  } else {
    return http.get(`/api/gameplay/${reqType}`);
  }
}

const AuthService = {
  signup,
  login,
  logout,
  verify,
  gameplay
};

export default AuthService;
